// Array of special characters to count as 2
const SPECIAL_CHARACTERS = ['€', '[', ']', '^', '{', '|', '}', '~', '\\'];

const isSpecialCharacter = (char: string) => {
  return SPECIAL_CHARACTERS.includes(char);
};

export const MAX_CHARS_PER_SMS = 612;

export const calculateCharacterCount = (text: string) => {
  let count = 0;

  for (let i = 0; i < text.length; i++) {
    if (text[i] === ' ' || text[i] === '\n') {
      // space or newline
      count++;
    } else if (isSpecialCharacter(text[i])) {
      // character is special
      count += 2;
    } else {
      // other characters
      count++;
    }
  }
  return count;
};
